import { useDebounce } from '@uidotdev/usehooks'
import React, { useState } from 'react'
import { useUpdateEffect } from 'react-use'

import { useUpdateOtherServiceMutation } from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/hooks/useUpdateOtherServiceMutation'
import FieldLabel from '@/components/form/FieldLabel'
import { Input } from '@/components/ui/input'
import { CompanyItem } from '@/types/responses/companies'

interface Props {
  company: CompanyItem
  isIfaFirm: boolean
}

const OtherServicesField: React.FC<Props> = ({ company, isIfaFirm }) => {
  const [otherServices, setOtherServices] = useState(
    company.otherServices || '',
  )

  const debouncedOtherServices = useDebounce(otherServices, 400)
  const updateOtherServiceMutation = useUpdateOtherServiceMutation()

  useUpdateEffect(() => {
    updateOtherServiceMutation.mutate(debouncedOtherServices)
  }, [debouncedOtherServices])

  return (
    <section className={isIfaFirm ? 'mt-4 text-left' : 'mt-6'}>
      <FieldLabel>Do you offer other services that aren't listed?</FieldLabel>

      <Input
        type="text"
        value={otherServices}
        onChange={(event) => setOtherServices(event.target.value)}
        placeholder="Enter comma-separated list of services"
      />
    </section>
  )
}

export default OtherServicesField
